export default __webpack_public_path__ + "static/media/close-white.115226f9.svg";